import React from "react";
import "./size-button.scss";
import { SizeSelectFieldSize } from "../../types";
import { SSRClassFix } from "../SSRClassFix";

export type SizeButtonProps = {
  size: SizeSelectFieldSize;
  isSelected: boolean;
  isDisabled?: boolean;
  onSelectSize: (size: SizeSelectFieldSize) => void;
  onDeselectSize: (size: SizeSelectFieldSize) => void;
};

const Tick = (): React.ReactElement => (
  <div className="c-size-button__selected-tick">
    <img
      className="c-size-button__selected-tick-img"
      alt="Selected Size Indicator"
      src={require("../../../../assets/tick.svg")}
    />
  </div>
);

export const SizeButton: React.FC<SizeButtonProps> = ({
  size,
  isSelected = false,
  isDisabled = false,
  onSelectSize,
  onDeselectSize,
}) => {
  const isLabelLong = (label: string) => label.length > 3;

  const handleClickSize = () => {
    if (!isDisabled) {
      if (isSelected) {
        onDeselectSize(size);
      } else {
        onSelectSize(size);
      }
    }
  };

  return (
    <SSRClassFix>
      <div
        className={`c-size-button ${isSelected ? "c-size-size-button--selected" : ""} ${
          isDisabled ? "c-size-size-button--disabled" : ""
        }`}
        data-value={size.sizeId}
        data-testid="size-button"
        onClick={handleClickSize}
      >
        {isSelected && <Tick />}
        <p className={isLabelLong(size.label) ? "c-size-button__size-label--long" : "c-size-button__size-label--short"}>
          {size.label}
        </p>
      </div>
    </SSRClassFix>
  );
};
